// extracted by mini-css-extract-plugin
var _1 = "csGWFWxTRFhtyjee8unO";
var _2 = "csGWFWxTRFhtyjee8unO";
var _3 = "nZyTa8dnYPmL2zJkp4Vm";
var _4 = "VleG67c6wIF1bsA7rQwN";
var _5 = "VleG67c6wIF1bsA7rQwN";
export { _1 as "margin-bottom-control-label", _2 as "marginBottomControlLabel", _3 as "questions", _4 as "ratings-questions", _5 as "ratingsQuestions" }
